import axios from '@/lib/axios';
import { useQuery } from '@tanstack/react-query';
import { FixedAsset, Pager } from '@/hooks/api/models';
import queryClient from '@/lib/queryClient';

/**
 * 2000. 固定資産一覧
 * [GET] /workspaces/:identifier/fixed_assets
 */
type Props = {
  identifier: string;
  page: number;
  per: number;
  fixed_asset_status_id?: number;
};

type FixedAssetsResponse = {
  fixed_assets: FixedAsset[];
  pager: Pager;
};

const fixedAssets = (props: Props): Promise<FixedAssetsResponse> => {
  return axios.get(`/api/workspaces/${props.identifier}/fixed_assets`, { params: props });
};

export const useFixedAssets = (props: Props) => {
  return useQuery({
    queryKey: ['workspaces', props.identifier, 'fixed_assets', 'pager', props.page, props.per],
    queryFn: () => fixedAssets(props),
  });
};

export const useInvalidateFixedAssets = (identifier: string) => {
  const invalidate = async () => {
    await queryClient.invalidateQueries({ queryKey: ['workspaces', identifier, 'fixed_assets'] });
  };

  return { invalidate };
};
